import { useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import cn from 'bem-cn';

import { useSearch } from '../../../store';
import { useNavigateBack } from '../../../hooks';
import { isLightThemeRoute } from '../../../utils/theme';
import { Search, Stack } from '../../UI';
import { BackButton } from '../../BackButton';

import { HeaderSearchProps } from './HeaderSearch.types';
import './HeaderSearch.scss';

const b = cn('header-search');

export const HeaderSearch = (props: HeaderSearchProps) => {
    const { searchQuery, handleSearch } = useSearch();
    const navigateBack = useNavigateBack();

    const { onSearchOpen, onSearchClose, className, isActive } = props;

    const location = useLocation();
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [isFocused, setIsFocused] = useState<boolean>(false);

    const isSearchSecondary = !isLightThemeRoute(location.pathname);
    const isExpanded = isActive || isFocused || Boolean(searchQuery.trim().length);

    const handleFocus = () => {
        setIsFocused(true);
        onSearchOpen?.();
    };

    const handleBlur = () => {
        setIsFocused(false);

        if (!isActive) {
            onSearchClose?.();
        }
    };

    const handleSearchClose = () => {
        navigateBack();
        onSearchClose?.();
    };

    return (
        <Stack className={b({ focused: isFocused }).mix(className)} direction="row" spacing={8} alignItems="center">
            {isActive && <BackButton />}
            <Search
                ref={searchInputRef}
                value={searchQuery}
                onSearch={handleSearch}
                onFocus={handleFocus}
                onBlur={handleBlur}
                placeholder="Хочу научиться рисовать"
                expanded={isExpanded}
                secondary={isSearchSecondary}
                className={b('search')}
            />
            {isActive && (
                <button className={b('mobile-back-button')} onClick={handleSearchClose}>
                    Отмена
                </button>
            )}
        </Stack>
    );
};
